import { FC } from 'react';

interface WarningIconProps {
  width?: number;
  height?: number;
  fill?: string;
  classes?: string;
}

const WarningIcon: FC<WarningIconProps> = ({
  width = 20,
  height = 20,
  fill = '#D52300',
  classes = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
    >
      <path
        d="M1.14124 22.5086C0.926585 22.5086 0.733775 22.4561 0.562811 22.3512C0.391847 22.2463 0.25898 22.108 0.164211 21.9362C0.0654317 21.7656 0.0110819 21.581 0.00116175 21.3821C-0.0087584 21.1833 0.0448524 20.9864 0.161995 20.7914L11.0033 2.06381C11.1207 1.86878 11.2674 1.72462 11.4434 1.63133C11.6197 1.53804 11.8052 1.49139 12 1.49139C12.1948 1.49139 12.3803 1.53804 12.5566 1.63133C12.7326 1.72462 12.8793 1.86878 12.9967 2.06381L23.838 20.7914C23.9551 20.9864 24.0088 21.1833 23.9988 21.3821C23.9889 21.581 23.9346 21.7656 23.8358 21.9362C23.741 22.108 23.6082 22.2463 23.4372 22.3512C23.2662 22.4561 23.0734 22.5086 22.8588 22.5086H1.14124ZM2.43867 20.609H21.5613L12 4.14577L2.43867 20.609ZM12 19.0991C12.2898 19.0991 12.5327 19.0011 12.7288 18.805C12.9249 18.6089 13.0229 18.366 13.0229 18.0762C13.0229 17.7864 12.9249 17.5435 12.7288 17.3474C12.5327 17.1513 12.2898 17.0533 12 17.0533C11.7102 17.0533 11.4673 17.1513 11.2712 17.3474C11.0751 17.5435 10.9771 17.7864 10.9771 18.0762C10.9771 18.366 11.0751 18.6089 11.2712 18.805C11.4673 19.0011 11.7102 19.0991 12 19.0991ZM12.0003 15.7869C12.2696 15.7869 12.4952 15.6959 12.6769 15.5139C12.8588 15.3318 12.9498 15.1062 12.9498 14.8371V10.4046C12.9498 10.1355 12.8587 9.91001 12.6766 9.72807C12.4944 9.54592 12.2688 9.45485 11.9997 9.45485C11.7304 9.45485 11.5048 9.54592 11.3231 9.72807C11.1412 9.91001 11.0502 10.1355 11.0502 10.4046V14.8371C11.0502 15.1062 11.1413 15.3318 11.3234 15.5139C11.5056 15.6959 11.7312 15.7869 12.0003 15.7869Z"
        fill={fill}
      />
    </svg>
  );
};

export default WarningIcon;
